<template>
  <el-tooltip placement="top" content="ブランド名を入力すると候補が表示されます">
    <el-select
      id="selector-brand"
      :value="value"
      filterable
      remote
      :remote-method="queryBrands"
      :loading="queryLoading"
      :size="size"
      :clearable="clearable"
      :placeholder="'ブランド名を入力してください'"
      @change="$emit('change', $event)"
    >
      <el-option
        v-for="item in brandOptions"
        :key="item.id"
        :label="item.name + ' / ' + item.phonetic"
        :value="item.id"
        :id="'selector-brand-option-' + item.id"
      >
      </el-option>
    </el-select>
  </el-tooltip>
</template>

<script>
import api from '@/http/api.js'

export default {
  name: 'BrandSelectorCore',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Number
    },
    category1st: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      queryLoading: false,
      brandOptions: []
    }
  },
  mounted: function () {
    if (this.value !== null && this.value !== '' && this.brandOptions.length === 0) {
      api.brand.getBrand(this.value).then(data => {
        this.brandOptions = data
      })
    }
  },
  watch: {
    value: function (val) {
      if (val !== null && val !== '' && this.brandOptions.length === 0) {
        api.brand.getBrand(val).then(data => {
          this.brandOptions = [data]
        })
      }
    }
  },
  methods: {
    queryBrands: function (query) {
      this.queryLoading = true
      api.brand.queryBrands(query).then(
        data => {
          this.brandOptions = data
          this.queryLoading = false
        }
      ).catch(
        e => {
          this.queryLoading = false
        }
      )
    }
  }
}
</script>
